import { TrackingRow } from 'pages/certificates/components'
import {
  HeroVariant,
  type HeroVariantProps,
} from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import { PassOnlyHeroModule } from '../PassOnlyHeroModule'

export const HeroVariantPassOnlyNoPrice = (props: HeroVariantProps) => (
  <TrackingRow
    row_name='hero-subs-only-no-price'
    location='hero-subs-only-no-price'
    visibilityConfig={{ threshold: 0.01 }}
  >
    <HeroVariant {...props} releaseLabel={props.program.releaseLabel}>
      <PassOnlyHeroModule logosAboveCta />
    </HeroVariant>
  </TrackingRow>
)
